import { createSelector } from 'reselect';

const getOnlineRegs = state => state.onlineTesting.onlineRegs;
const getOnlinePsiRegs = state => state.onlineTesting.onlinePsiRegs;
const getRoom = state => state.roomOptions.room;

export const mapOnlineRegs = createSelector(
  [getOnlineRegs, getRoom],
  (regs, room) => {
    let result = [];
    regs && room && regs.map(reg => {
      if (!result[reg.seatRow]) {
        result[reg.seatRow] = [];
      }
      reg.roomId = room.id;

      result[reg.seatRow][reg.seatCol] = reg;
    });

    return result;
  }
);
export const mapOnlinePsiRegs = createSelector(
  [getOnlinePsiRegs, getRoom],
  (regs, room) => {
    let result = [];
    regs && room && regs.map(reg => {
      if (!result[reg.seatRow]) {
        result[reg.seatRow] = [];
      }
      reg.roomId = room.id;

      result[reg.seatRow][reg.seatCol] = reg;
    });

    return result;
  }
);